import '../_scss/cms.scss';

import "./_icons";
import './_global';
import './carousels/_home_slider';

import './carousels/_academic';


// retina shenanigans from previous design.
// I don't get it so I just copied it as it is (except it was jquery before)
window.addEventListener('DOMContentLoaded', (event) => {
    if(window.devicePixelRatio >= 2) {
        document.querySelectorAll('[data-retina]').forEach(function(img) {
            img.setAttribute('src', img.getAttribute('data-retina'));
        });
    }
});


// blog mobile contents fold/unfold
window.addEventListener('DOMContentLoaded', (event) => {
	document.querySelectorAll('.mp-table-contents.sticky h4').forEach(function(btn) {
		btn.addEventListener('click', function() {
			this.closest('.mp-table-contents.sticky').classList.toggle('open');
		});
	});
});


// кнопка прокрутки до блока с категориями
// document.querySelectorAll('.scroll__to_list').forEach($button => {
//   $button.addEventListener('click', () => {
//     const listPosY = document.querySelector('.category-view')?.getBoundingClientRect().top;

//     if (listPosY) {
//       const pos = listPosY - (breakpointDown('lg') ? 0 : 100);

//       if ('scrollBehavior' in document.documentElement.style) {
//         window.scroll({
//           top: pos,
//           left: 0,
//           behavior: 'smooth'
//         });
//       } else if (window.scroll) {
//         window.scroll(0, pos);
//       } else {
//         window.document.documentElement.scrollTop = pos;
//       }
//     }
//   });
// });
